
export interface RabbitMqConnectionSettings {
    connectionString: string;
}
